import { NgModule, inject } from '@angular/core';
import { Routes, RouterModule, CanActivateFn, Router } from '@angular/router';
import { MyItemsComponent } from './my-items/my-items.component';
import { AuthService } from './services/auth.service';

import { antiqryAuthGuard } from './guards/antiqry-auth.guard';
import { adminGuard } from './guards/admin.guard';
export { antiqryAuthGuard, adminGuard };

export const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'signup', redirectTo: 'auth/sign-up', pathMatch: 'full' },
  { path: 'sign-up', redirectTo: 'auth/sign-up', pathMatch: 'full' },
  { path: 'items', loadChildren: () => import('./item/item.module').then(m => m.ItemModule) },
  { path: 'item/:id', redirectTo: 'items/:id' },
  { path: 'item', redirectTo: 'items' },
  { path: 'offers', loadChildren: () => import('./offers/offers.module').then(m => m.OffersModule), canActivate: [antiqryAuthGuard] },
  { path: 'profile', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule), canActivate: [antiqryAuthGuard] },
  { path: 'search', loadChildren: () => import('./search/search.module').then(m => m.SearchModule) },
  { path: 'my-items', component: MyItemsComponent, canActivate: [antiqryAuthGuard] },
  { path: 'admin', loadComponent: () => import('./admin/admin-portal/admin-portal.component').then(m => m.AdminPortalComponent), canActivate: [adminGuard] },
  { path: 'admin/portal', redirectTo: 'admin', pathMatch: 'full' },
  { path: 'admin/dealers', loadComponent: () => import('./admin/dealers-dashboard/dealers-dashboard.component').then(m => m.DealersDashboardComponent), canActivate: [adminGuard] },
  { path: 'claim-gallery', loadComponent: () => import('./claim-gallery/claim-gallery.component').then(m => m.ClaimGalleryComponent) },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}